module.exports = "/images/privacy_policy.svg?b78e352e2e5022ee58260ae512651df3";